import { createAsyncThunk } from "@reduxjs/toolkit";
import dayjs from "dayjs";

import { type CreatorMonthStats } from "@fitness-app/data-models/entities/Reports";
import { getErrorMessage } from "@fitness-app/utils";

import { type AsyncThunkCreator } from "../../../index";
import { getParentTrainerId } from "../../user/selectors";
import { STATISTICS_REDUCER_NAME } from "../types";

export const fetchCurrentMonthStats = createAsyncThunk<CreatorMonthStats | null, void, AsyncThunkCreator<string>>(
  `${STATISTICS_REDUCER_NAME}/fetchCurrentMonthStats`,
  async (_, { rejectWithValue, getState, extra: { db } }) => {
    try {
      const parentId = getParentTrainerId(getState());

      if (!parentId) {
        throw new Error("user-is-not-logged");
      }

      const { data, error } = await db
        .from("creator_month_stats")
        .select("*")
        .eq("creator", parentId)
        .eq("monthYear", dayjs().format("YYYY-M"))
        .maybeSingle<CreatorMonthStats>();

      if (error) {
        return rejectWithValue(error.message);
      }

      return data;
    } catch (e) {
      return rejectWithValue(getErrorMessage(e));
    }
  },
);
